import { FieldErrors, UseFormRegister } from "react-hook-form";
import { WhatsNewRuleForm } from "../Models/WhatsNewRuleForm";
import { Box, Grid,  Tab,  useMediaQuery, useTheme } from "@mui/material";
import { LanguageConsumer, getTranslation } from "../../../../../../Infrastructure/Internationalisation/TranslationService";
import { CustomBoxHeader } from "../../../../../../Layout/CustomBox";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { TextFieldFormControl } from "../../../../../../Layout/Inputs/TextFieldFormControl";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from 'quill-image-resize-module-react';
import { blue, deepPurple, indigo, lightGreen, lime, orange, purple, red, teal } from "@mui/material/colors";
import 'react-quill/dist/quill.snow.css';
import './Styles/WhatsNewCreateOrEdit.css';



Quill.register('modules/imageResize', ImageResize)

const modules = {
    toolbar: {
        container: [
            [{ 'header': [2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean'],
            [
                {
                    color: ["#32992c", "#54ac51", lightGreen[500], teal[500], lime[500], orange[500], indigo[500], blue[500], deepPurple[500], red[500], purple[500]],
                },
            ],
        ]
    },
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'width', 'color'
];


interface WhatsNewContentProps {
    currentLanguageToEdit: 'de' | 'en',
    setCurrentLanguageToEdit: React.Dispatch<React.SetStateAction<"de" | "en">>,
    isSaving: boolean,
    register: UseFormRegister<WhatsNewRuleForm>,
    errors: FieldErrors<WhatsNewRuleForm>,    
    contentDe: string,
    contentEn: string,
    contentCn: string,    
    setContentDe: React.Dispatch<React.SetStateAction<string>>,
    setContentEn: React.Dispatch<React.SetStateAction<string>>,
    setContentCn: React.Dispatch<React.SetStateAction<string>>,
    contentDeRef: React.MutableRefObject<null>,
    contentEnRef: React.MutableRefObject<null>,
    contentCnRef: React.MutableRefObject<null>,    
}

export const WhatsNewContent = (props: WhatsNewContentProps) => {
    const { currentLanguageToEdit, 
            setCurrentLanguageToEdit, 
            isSaving, 
            register, 
            errors,             
            contentDe, contentEn, contentCn,             
            setContentDe, setContentEn, setContentCn,
            contentDeRef, contentEnRef, contentCnRef } = props;
    const isMobile = useMediaQuery('(max-width:500px)');    
    const theme = useTheme();

    const checkThis = (label: string) => {        
        if((label==="German" && errors.WhatsNewHeaderDe) || (label==="English" && errors.WhatsNewHeaderEn) || (label==="Chinese" && errors.WhatsNewHeaderCn))
        {
            return <span dangerouslySetInnerHTML={{ __html: '<b style="color:#d32f2f">'+ getTranslation(label) + '</b>' }}></span>;
        }
        else{
            return getTranslation(label);   
        }         
    }   

    return (
        <LanguageConsumer>
            {({ getTranslatedText }) =>
                <>
                    <CustomBoxHeader text={getTranslatedText("WhatsNewContent")} sx={{mb: 4}} />
                    <TabContext value={currentLanguageToEdit}>
                        <Box component={'div'} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList sx={{ mt: -2 }} orientation={isMobile ? "vertical" : "horizontal"} onChange={(event: React.SyntheticEvent, newValue: 'de' | 'en') => setCurrentLanguageToEdit(newValue)} aria-label="lab API tabs example">
                                <Tab label={checkThis("German")} value="de" />
                                <Tab label={checkThis("English")} value="en" />
                                <Tab label={checkThis("Chinese")} value="cn" />
                            </TabList>
                        </Box>
                        <TabPanel value="de" sx={{ p: 0, pt: 3 }}>
                            <Grid container direction={'row'} spacing={2}>
                                <Grid item xs={12}>
                                    <TextFieldFormControl
                                        disabled={isSaving}
                                        inputProps={{ "data-testid": "helpCreateOrEdit-Title" }}
                                        hasEndAdornment={false}
                                        labelText={getTranslatedText('WhatsNewHeader')}
                                        propertyName='WhatsNewHeaderDe'
                                        register={register} registerOptions={{ valueAsNumber: false }} errors={errors} />
                                </Grid>
                                <Grid item xs={12}>
                                    <ReactQuill style={{height: 400, marginBottom: 45}} 
                                    ref={contentDeRef} modules={modules} formats={formats} theme="snow" value={contentDe} onChange={setContentDe} />
                                </Grid>                                                             
                            </Grid>
                        </TabPanel>
                        <TabPanel value="en" sx={{ p: 0, pt: 3 }}>
                            <Grid container direction={'row'} spacing={2}>
                                <Grid item xs={12}>
                                    <TextFieldFormControl
                                        disabled={isSaving}
                                        inputProps={{ "data-testid": "helpCreateOrEdit-Title" }}
                                        hasEndAdornment={false}
                                        labelText={getTranslatedText('WhatsNewHeader')}
                                        propertyName='WhatsNewHeaderEn'
                                        register={register} registerOptions={{ valueAsNumber: false }} errors={errors} />
                                </Grid>
                                <Grid item xs={12}>
                                    <ReactQuill style={{height: 400, marginBottom: 45}}                                    
                                    ref={contentEnRef} modules={modules} formats={formats} theme="snow" value={contentEn} onChange={setContentEn} />
                                </Grid>
                                                            
                            </Grid>
                        </TabPanel>
                        <TabPanel value="cn" sx={{ p: 0, pt: 3 }}>
                            <Grid container direction={'row'} spacing={2}>
                                <Grid item xs={12}>
                                    <TextFieldFormControl
                                        disabled={isSaving}
                                        inputProps={{ "data-testid": "helpCreateOrEdit-Title" }}
                                        hasEndAdornment={false}
                                        labelText={getTranslatedText('WhatsNewHeader')}
                                        propertyName='WhatsNewHeaderCn'
                                        register={register} registerOptions={{ valueAsNumber: false }} errors={errors} />
                                </Grid>
                                <Grid item xs={12}>
                                    <ReactQuill style={{height: 400, marginBottom: 45}} 
                                    ref={contentCnRef} modules={modules} formats={formats} theme="snow" value={contentCn} onChange={setContentCn} />
                                </Grid>                                                               
                            </Grid>
                        </TabPanel>
                    </TabContext>
                </>
            }
        </LanguageConsumer>
    )
}